import { sendRequest, showErrorMessages } from "../../../functions";
import PhoneInput from "../../formio/components/phone-input";
import { calculateTotalAmount, restyleFormButtons, setBackendValidationRules } from "../../formio/functions";



// Fonction pour initialiser le formulaire
function initializeForm() {


    $(document).ready(() => {
        $(window).on("load", function () {
            $("html, body").scrollTop(0);
        });

        Formio.use({
            components: {
                phoneinput: PhoneInput,
            },
        });

        Formio.createForm(document.getElementById("form"), {
            components: JSON.parse(formComponents),
        }).then((form) => {
            restyleFormButtons();
            $("#form").show();

            let formData = {};

            calculateTotalAmount(form);

            form.on("submit", function (submission) {
                $("#inProgressModal").modal("show");
                let validationRules = setBackendValidationRules(form);


                formData = Object.assign(formData, submission.data);
                formData.organization_id = organizationId;
                formData.rules = JSON.stringify(validationRules);

                // Envoi de la demande
                sendRequest(formSubmitUrl, "POST", formData)
                    .fail((response) => {
                        showErrorMessages(response, '#errorAlert')
                    })
                    .always(() => {
                        // Cacher la modal de progression
                        setTimeout(() => {
                            $("#inProgressModal").modal("hide");
                        }, 300);
                    });
            });
        });
    });
}



$('#newAdherent').click(function () {
    initializeForm();
    document.getElementById("form").removeAttribute("hidden");
    $('#ask-form').hide();
    $('#backBtn').show();
});



$(() => {
    $(document).ajaxSuccess(function (event, request, settings) {
        if (request.responseJSON && request.responseJSON.url) {
            window.location.href = request.responseJSON.url;
        }
    })
    $(document).ajaxError(function (event, data, settings) {

        for (let key in data.responseJSON.errors) {
            let errorMessage = data.responseJSON.errors[key];

            $('.alert-success').attr('class', 'alert alert-danger')
                .text('')
                .append('<ul>').append(
                    $("<li>").text(errorMessage)
                );
        }
    });

    $(document).ajaxSend(function (event, xhr, settings) {
        if (settings.url.includes('register')) {
            settings.data += "&" + encodeURIComponent('code') + "=" + encodeURIComponent($("#code")
                .val());
        }
    });


});

